import { useEffect } from 'react';

export function SplashScreen({ children }) {
  // Remove HTML splash immediately when React is ready
  useEffect(() => {
    const htmlSplash = document.getElementById('html-splash');
    if (htmlSplash) {
      htmlSplash.classList.add('hide');
      setTimeout(() => htmlSplash.remove(), 400);
    }
  }, []);

  return children;
}
